import { Slide } from '@/components/core/Slide';

export const slide = () => {
  return (
    <Slide
      notes="Introduction to agents concept"
      visualizer="bottom-right"
      networkBackground="full"
      transition="fade"
    >
      <div className="slide relative z-10">
        <h1>Wat zijn AI Agents</h1>
        <ul>
          <li>Zelfstandig beslissingen kunnen nemen</li>
          <li>Een doel nastreven zonder directe menselijke input</li>
          <li>Kunnen leren van hun interacties</li>
        </ul>
      </div>
    </Slide>
  );
};
